import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CRM.css';

const NAV_ITEMS = [
  { to: '/crm', label: 'Dashboard', exact: true },
  { to: '/crm/monday', label: 'Monday Tasks', highlight: true },
  { to: '/crm/calendar', label: 'Calendar' },
  { to: '/crm/no-contact', label: '30-Day No Contact' },
  // Call-first log. Customer-scoped history lives on the customer page, which keeps its
  // own tab - an unmatched call has nowhere to appear in a customer-scoped view.
  { to: '/crm/calls', label: 'Call Log' },
  { to: '/crm/customers', label: 'Customers' },
  { to: '/crm/leads', label: 'Leads' },
  { to: '/crm/pipeline', label: 'Pipeline' },
  { to: '/crm/tasks', label: 'Tasks' },
];

const CRMSubNav: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  const isActive = (item: typeof NAV_ITEMS[number]) => {
    if (item.exact) return path === item.to;
    return path.startsWith(item.to);
  };

  return (
    <>
      <Link to="/dashboard" className="crm-back-to-admin">← Back to Admin</Link>
      <nav className="crm-subnav">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item);
          const classes = [
            'crm-subnav-link',
            active ? 'active' : '',
            item.highlight && !active ? 'crm-subnav-link-highlight' : '',
          ].filter(Boolean).join(' ');

          return (
            <Link key={item.to} to={item.to} className={classes}>
              {item.label}
            </Link>
          );
        })}
      </nav>
    </>
  );
};

export default CRMSubNav;
